import React from "react";
import url from "../../helpers/url";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import { UserContext } from "../../context/user";
import { ExtraContext } from "../../context/ExtraFunctions";

const GoogleAuth = () => {
  const { get_user } = React.useContext(UserContext);
  const { handleAlert, setGif } = React.useContext(ExtraContext);

  let history = useHistory();
  let params = useLocation();
  let access_token = params.search.slice(21);

  React.useEffect(() => {
    const GoogleAuth = async () => {
      setGif(true);
      let response = await axios
        .get(`${url}/auth/google/callback?id_token=${access_token}`)
        .catch((error) => console.clear());
      return response;
    };

    const callBack = async () => {
      setGif(false);
      let response = await GoogleAuth();
      if (response) {
        let {
          jwt: token,
          user: { username, id },
        } = response.data;
        const newUser = { token, username, id };
        get_user(newUser);
        history.push("/");
        setGif(false);
        handleAlert({
          show: true,
          type: "success",
          text: ` Welcome ${username}`,
        });
      } else {
        setGif(false);
        handleAlert({
          show: true,
          type: "error",
          text: "Something went wrong",
        });
        history.push("/");
      }
    };
    callBack();
  }, []);

  return (
    <div className="center-text">
      <h5>You will be redirected shortly</h5>
    </div>
  );
};

export { GoogleAuth as default };
